module.exports = __webpack_public_path__ + "img/406.2988fae1.png";